import { useEffect, useState } from "react";
import { Play, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { Output } from "@/components/machine/QuickDialogs";

const AddTool = ({ onAdded }) => {
  const [f, setF] = useState({ name: "", command: "", shell: "powershell" });
  const add = async () => {
    try { await api.post("/toolbox", f); setF({ name: "", command: "", shell: "powershell" }); onAdded(); toast.success("Commande ajoutée"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="grid grid-cols-[1fr_2fr_auto_auto] gap-2 items-center border-t pt-3">
      <Input placeholder="Nom" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="tool-name-input" />
      <Input placeholder="Commande" className="font-mono" value={f.command} onChange={(e) => setF({ ...f, command: e.target.value })} data-testid="tool-command-input" />
      <select className="h-9 border rounded-md px-2 text-sm" value={f.shell} onChange={(e) => setF({ ...f, shell: e.target.value })} data-testid="tool-shell-select">
        <option value="powershell">PowerShell</option><option value="cmd">Invite de commandes</option><option value="auto">Mac / Linux</option>
      </select>
      <Button size="sm" onClick={add} disabled={!f.name.trim() || !f.command.trim()} data-testid="tool-add-btn"><Plus className="h-4 w-4" /></Button>
    </div>
  );
};

export const ToolboxDialog = ({ m, onClose }) => {
  const [tools, setTools] = useState([]);
  const [running, setRunning] = useState(null);
  const [res, setRes] = useState(null);
  const load = () => api.get("/toolbox").then(({ data }) => setTools(data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { if (m) { load(); setRes(null); } }, [m]);
  const run = async (t) => {
    setRunning(t.tool_id); setRes(null);
    try { setRes((await api.post(`/toolbox/${t.tool_id}/run`, { machine_ids: [m.machine_id] }, { timeout: 140000 })).data[0]); }
    catch (e) { toast.error(errMsg(e)); } finally { setRunning(null); }
  };
  const del = (t) => window.confirm(`Supprimer « ${t.name} » ?`) && api.delete(`/toolbox/${t.tool_id}`).then(load).catch((e) => toast.error(errMsg(e)));
  return (
    <Dialog open={!!m} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl" data-testid="toolbox-dialog">
        <DialogHeader><DialogTitle>Boîte à commandes — {m?.display_name || m?.hostname}</DialogTitle></DialogHeader>
        <div className="max-h-72 overflow-auto divide-y">
          {tools.map((t) => (
            <div key={t.tool_id} className="flex items-center gap-3 py-2" data-testid={`tool-${t.tool_id}`}>
              <div className="flex-1 min-w-0"><p className="font-medium text-sm">{t.name}</p><p className="text-xs text-slate-500 font-mono truncate">{t.command}</p></div>
              <Button size="sm" onClick={() => run(t)} disabled={!!running} data-testid={`tool-run-${t.tool_id}`}><Play className="h-4 w-4 mr-1" />{running === t.tool_id ? "…" : "Lancer"}</Button>
              <Button size="sm" variant="ghost" onClick={() => del(t)} data-testid={`tool-delete-${t.tool_id}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          ))}
        </div>
        <AddTool onAdded={load} />
        {res && <Output r={res} />}
      </DialogContent>
    </Dialog>
  );
};
